import React from 'react';
import './ExportPanel.css';

interface PlacedBlock {
    x: number;
    y: number;
    texture: string;
}

interface ExportPanelProps {
    blocks: PlacedBlock[];
}

const ExportPanel: React.FC<ExportPanelProps> = ({ blocks }) => {
    const generateTileConfigs = () => {
        return blocks.map((block, index) => ({
            component: 'Tile',
            props: {
                tx: block.x * 32, // Convert grid position to pixel position
                ty: block.y * 32,
                texture: `/textures/${block.texture}`
            },
            key: `tile-${index + 1}`
        }));
    };

    const generateJSON = () => {
        const configs = generateTileConfigs();
        return JSON.stringify(configs, null, 2);
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(generateJSON());
            alert('JSON copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = generateJSON();
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                alert('JSON copied to clipboard!');
            } catch (err) {
                alert('Failed to copy to clipboard');
            }
            document.body.removeChild(textArea);
        }
    };

    const downloadJSON = () => {
        const jsonContent = generateJSON();
        const blob = new Blob([jsonContent], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'block-layout.json';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const generateHomeCode = () => {
        const configs = generateTileConfigs();
        const configString = JSON.stringify(configs, null, 8).replace(/"/g, "'");
        
        return `// Add these tile configurations to your components array in Home.tsx:
const tileConfigs = ${configString};

// Then in your components array, spread these configs:
const components: ComponentConfig[] = [
    // ... existing circle components ...
    ...tileConfigs
];`;
    };

    return (
        <div className="export-panel">
            <h3>Export Configuration</h3>
            
            <div className="export-stats">
                <p>Total blocks: {blocks.length}</p>
                <p>Canvas size: 20x15 grid (640x480 pixels)</p>
            </div>

            <div className="export-actions">
                <button onClick={copyToClipboard} className="export-button copy-btn">
                    📋 Copy JSON
                </button>
                <button onClick={downloadJSON} className="export-button download-btn">
                    💾 Download JSON
                </button>
            </div>

            <div className="code-preview">
                <h4>JSON Configuration:</h4>
                <pre className="json-preview">
                    {generateJSON()}
                </pre>
            </div>

            <div className="usage-instructions">
                <h4>How to use in Home.tsx:</h4>
                <pre className="code-example">
                    {generateHomeCode()}
                </pre>
            </div>
        </div>
    );
};

export default ExportPanel;